import * as React from 'react'
import { memo, useState } from 'react'
import { useOnClickOutside } from 'usehooks-ts'

import { useRollback } from './hooks'
import { setRollback, submitRollback } from './model'
import {
  CButton,
  CCol,
  CForm,
  CFormCheck,
  CFormFeedback,
  CFormInput,
  CFormLabel,
  CModal,
  CModalBody,
  CModalFooter,
  CModalHeader,
  CModalTitle,
  CRow,
} from '@coreui/react-pro'
import {
  transactionRequestDestinationType,
  transactionRequestStatus,
} from '../../../const'
import { Alert, Button, Divider, Tag } from 'antd'
import { DepositEdit } from '../../edit'
import { setReject } from '../rejectModal'

type Props = {
  request: DepositEdit
  className?: string
  color?: string
  disabled?: boolean
}

export const RollbackModal = ({
  request,
  className,
  color,
  disabled,
}: Props) => {
  const { rollback, isLoading } = useRollback()
  const [isVisible, setVisible] = React.useState(false)
  const ref = React.useRef(null)

  useOnClickOutside(ref, () => {
    if (isVisible) {
      setRollback('')
    }
  })

  let purseTitle = <span>Account ID: </span>

  if (request.destinationType == transactionRequestDestinationType.wallet()) {
    purseTitle = <span>Wallet ID: </span>
  }
  const [reason, setReason] = useState('')

  // @ts-ignore
  return (
    <>
      <Button
        type="primary"
        className={className}
        onClick={() => setVisible(true)}
        disabled={disabled}
      >
        Rollback
      </Button>
      <CModal visible={isVisible} onClose={() => setVisible(false)} size={'xl'}>
        <CForm
          className="row g-3 needs-validation"
          noValidate
          onSubmit={(e) => {
            const form = e.currentTarget
            e.preventDefault()
            setReason('')
            submitRollback({
              requestId: request.transactionId,
              // @ts-ignore
              rejectReason: rollback,
            })
            setVisible(false)
          }}
          id="rollbackForm"
        >
          <CModalHeader>
            <CModalTitle>Set reason</CModalTitle>
          </CModalHeader>
          <CModalBody>
            <CRow>
              <CCol>
                <strong>Created at</strong>: {request.createdAt}
              </CCol>
              <CCol>
                <strong>Updated at</strong>: {request.updatedAt}
              </CCol>
            </CRow>
            <Divider />
            <CRow className="mb-3 align-items-center">
              <CCol>
                <strong>ID</strong>: {request.transactionId}
              </CCol>
              <CCol>
                <strong>Client ID</strong>: {request.client.clientId}
              </CCol>
              <CCol>
                <strong>{purseTitle}</strong>: {request.destinationId}
              </CCol>
              <CCol>
                <strong>Processing type</strong>:{' '}
                <Tag color={request.isAuto ? '#2eb85c' : '#321fdb'}>
                  {request.isAuto ? 'Auto' : 'Manual'}
                </Tag>
              </CCol>
            </CRow>
            <Divider />

            <CRow>
              <CCol>
                <strong>clientPurseId</strong>: {request.clientPurseId}
              </CCol>
              {request.clientPurseId != 0 && (
                <>
                  <CCol>
                    <strong>isCard</strong>:{' '}
                    {Boolean(request.clientPurse?.isCard).toString()}
                  </CCol>
                  <CCol>
                    <strong>expiry</strong>: {request.clientPurse?.expiry}
                  </CCol>
                  <CCol>
                    <strong>mask</strong>: {request.clientPurse?.mask}
                  </CCol>
                  <CCol>
                    <strong>type</strong>: {request.clientPurse?.type}
                  </CCol>
                </>
              )}
            </CRow>
            <Divider />
            {reason.length > 0 && <Alert message={reason} type={'error'} />}
            <CFormLabel htmlFor="initialAmount" className="col-12">
              Rollback reason
            </CFormLabel>
            <CFormInput
              type="text"
              id="reason"
              name="reason"
              onChange={(e) => {
                setRollback(e.target.value)
              }}
            />
            <CFormFeedback invalid>Field is required</CFormFeedback>
          </CModalBody>
          <CModalFooter>
            <CButton color="secondary" onClick={() => setVisible(false)}>
              Cancel
            </CButton>
            <CButton
              color="primary"
              className="px-4"
              type="submit"
              disabled={isLoading}
            >
              {isLoading && (
                <span className="spinner-border spinner-border-sm"></span>
              )}
              Rollback
            </CButton>
          </CModalFooter>
        </CForm>
      </CModal>
    </>
  )
}
